import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { useTranslation } from 'react-i18next';
import { isAdminDashboard } from 'utils/authScopes';

const GroupCohortsHeader = ({ ages, auth, meta }) => {
  const { t } = useTranslation();
  const headers = meta.withages ? map(ages, a => <th key={a.value}>{a.label}</th>) : null;
  return (
    <thead>
      <tr>
        { isAdminDashboard(auth) && <th>{t('groupCohortsReport.columns.partner')}</th> }
        <th>{t('groupCohortsReport.columns.organizationType')}</th>
        <th>{t('groupCohortsReport.columns.title')}</th>
        <th>{t('groupCohortsReport.columns.level')}</th>
        <th>{t('groupCohortsReport.columns.numberOfChildren')}</th>
        { headers }
        <th>{t('groupCohortsReport.columns.completedAsqSe2')}</th>
        <th>{t('groupCohortsReport.columns.completedAsq3')}</th>
      </tr>
    </thead>
  );
}

GroupCohortsHeader.propTypes = {
  ages: PropTypes.arrayOf(PropTypes.object).isRequired,
  auth: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
}

export default GroupCohortsHeader;